import React, { FC } from 'react';

import { ClassName, cn } from '../../utils';
import { participantIcons } from '../../participantIcons';
import styles from './index.module.scss';
import {
    PlaceholderIcon,
    PlaceholderIconProps,
} from '../PlaceholderIcon';


export type ParticipantIconProps = ClassName & PlaceholderIconProps & {
    dltKey?: string;
    isFlash?: boolean;
}

export const ParticipantIcon: FC<ParticipantIconProps> = ({
    dltKey,
    className,
    shape = 'circle',
    ...props
}) => {
    const Icon = dltKey && participantIcons[dltKey];
    return (
        <div
            className={cn(
                styles.participant,
                className,
            )}
        >
            {Icon && <Icon shape={shape} /> || (
                <PlaceholderIcon
                    shape={shape}
                    {...props}
                />
            )}
        </div>
    );
};
